module.exports = __webpack_public_path__ + "static/img/2023年历-5.f663ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-5.jpg
// module id = nLJC
// module chunks = 3